module.exports = __webpack_public_path__ + "static/media/noun-plus.8bf831e9.svg";